import React, { FC } from 'react'
import {
  HeroBannerDetailComponent,
  HeroBannerDetailContent,
  HeroBannerDetailImage,
  HeroBannerDetailTitle,
  HeroBannerDetailIconMobile,
  HeroBannerDetailIcon,
} from './styled'

interface HeroBannerDetailProps {
  image: string
  title: string
  fontFamily?: string
  fontSizeM: string
  fontheightM: string
  subTitle?: string
  paragraph: string
  backgroundColor?: string
  secondaryColor?: string
  style?: object
}

const SVGIcon = () => {
  return (
    <svg
      width="95"
      height="19"
      viewBox="0 0 95 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.1127 11.1931C88.5209 13.2793 92.0083 12.4519 95 9.45193C94.6918 9.18362 94.3952 8.90526 94.0786 8.65321C90.9442 6.15541 87.8264 5.93828 84.6712 8.0855C83.9912 8.54823 83.3408 8.76082 82.5513 8.7051C81.9849 8.66493 81.4137 8.69674 80.8447 8.69674C80.5145 8.6965 80.1844 8.69674 79.8542 8.69674C81.7614 8.13141 83.5219 7.37406 84.7014 5.65394C85.8467 3.98332 86.2756 2.09365 86.3222 0.0844157C84.7222 -0.0602628 82.2137 0.682739 80.8327 1.72299C78.5573 3.43689 77.9787 5.96386 77.7405 8.66015H71.3877C73.3033 8.1393 75.0605 7.37693 76.2439 5.6537C77.3907 3.9838 77.8163 2.097 77.8678 0.000478276C77.1813 0.086568 76.5832 0.127939 75.9983 0.240573C73.6676 0.689196 71.6769 1.69047 70.4911 3.92545C69.7987 5.23043 69.444 6.64039 69.3635 8.1173C69.3401 8.54225 69.2341 8.71682 68.7704 8.70941C68.0588 8.69793 67.3473 8.69482 66.6355 8.6941L66.6353 8.66015H62.967C64.8739 8.12854 66.6093 7.359 67.7881 5.66064C68.9381 4.00365 69.3347 2.10968 69.4384 0C68.7493 0.0856114 68.1354 0.1277 67.5347 0.242486C64.9741 0.732719 62.8886 1.9131 61.7709 4.46782C61.2472 5.66446 60.9643 6.92161 60.8958 8.22492C60.8831 8.46716 60.8312 8.59869 60.6936 8.66015H54.623C56.5044 8.11922 58.2399 7.35828 59.4135 5.65849C60.5675 3.98739 60.9751 2.09246 61.0523 0.0365881C59.1501 0.12196 57.3987 0.483776 55.8442 1.51924C53.3368 3.18938 52.7158 5.82803 52.4535 8.66015H46.2351C48.1507 8.1393 49.9078 7.37693 51.0911 5.6537C52.238 3.9838 52.6637 2.097 52.7151 0.000478276C52.0286 0.086568 51.4306 0.127939 50.8456 0.240573C48.515 0.689196 46.5243 1.69047 45.3387 3.92545C44.6461 5.23043 44.2914 6.64039 44.2109 8.1173C44.1877 8.54225 44.0815 8.71682 43.6178 8.70941C41.7974 8.68023 39.9763 8.69889 38.1553 8.69721C38.0415 8.69697 37.9276 8.67306 37.8137 8.66039C39.7211 8.12878 41.4565 7.35924 42.6355 5.66064C43.7855 4.00365 44.1821 2.10968 44.2858 0C43.5967 0.0856114 42.9827 0.1277 42.3821 0.242486C39.8214 0.732719 37.736 1.9131 36.6182 4.46782C36.0946 5.66446 35.8117 6.92161 35.7432 8.22492C35.724 8.59032 35.6201 8.70774 35.2586 8.70463C33.4052 8.6886 31.5519 8.69793 29.6985 8.69674C29.6075 8.69674 29.5167 8.68143 29.4259 8.6733C31.3247 8.13165 33.0781 7.37191 34.2611 5.65849C35.4149 3.98739 35.8225 2.09246 35.8997 0.0365881C33.9974 0.12196 32.2461 0.483776 30.6915 1.51924C28.1732 3.1968 27.5576 5.85123 27.2972 8.69721C26.5571 8.69721 25.8603 8.69721 25.1635 8.69745C23.3102 8.69769 2.72648 8.69411 0.873123 8.70056C0.253544 8.70271 -0.108657 9.12599 0.0291575 9.68318C0.144042 10.1469 0.480739 10.2805 0.919217 10.2794C3.26042 10.2724 24.3317 10.2765 26.6729 10.277C26.8786 10.277 27.0843 10.277 27.3089 10.277C27.4989 12.67 27.961 14.9062 29.666 16.6141C31.3773 18.3283 33.5529 18.8056 35.9144 18.9464C35.6709 14.476 33.9518 11.2995 29.3827 10.3523C29.5645 10.292 29.7034 10.2782 29.8422 10.2779C31.5818 10.2765 33.3215 10.2772 35.0609 10.2772C35.8068 10.277 35.7184 10.2662 35.7453 10.9473C35.7551 11.1952 35.8012 11.4418 35.8314 11.6888C36.2855 15.4034 38.2596 17.7237 41.7621 18.5932C42.5679 18.7934 43.4053 18.8615 44.289 19C44.0485 14.4803 42.3302 11.2998 37.8179 10.3014H44.1414C44.3185 12.6425 44.7795 14.8818 46.4733 16.5938C48.1773 18.3161 50.3524 18.8063 52.7278 18.9409C52.5144 14.4459 50.7563 11.295 46.2362 10.3076H52.4641C52.6557 12.6891 53.1209 14.9136 54.8186 16.6141C56.5299 18.3283 58.7055 18.8056 61.0671 18.9464C60.8232 14.476 59.1044 11.2995 54.5353 10.3523C54.5961 10.332 54.6511 10.3186 54.704 10.3076H60.743C60.9093 10.3621 60.8808 10.5154 60.8979 10.9473C60.9075 11.1952 60.9538 11.4418 60.984 11.6888C61.4381 15.4034 63.4122 17.7237 66.9147 18.5932C67.7205 18.7934 68.5579 18.8615 69.4417 19C69.2014 14.4889 67.4889 11.3119 62.9957 10.3076H66.6421V10.3014H69.294C69.4711 12.6425 69.9321 14.8818 71.6259 16.5938C73.3299 18.3161 75.505 18.8063 77.8804 18.9409C77.6672 14.4459 75.9089 11.295 71.3888 10.3076H77.747C77.9305 12.6564 78.3907 14.895 80.0903 16.6038C81.7986 18.3218 83.9749 18.8065 86.3308 18.9424C86.2611 16.848 85.8345 14.9516 84.6749 13.2822C83.4961 11.5853 81.7373 10.8514 79.8482 10.3305C80.7148 10.2772 81.5609 10.3169 82.4018 10.2662C83.2755 10.2131 84.0762 10.3083 84.7404 10.9578C84.8436 11.0587 84.9873 11.1163 85.1127 11.1931Z"
        fill="currentColor"
      />
    </svg>
  )
}

const HeroBannerDetail: FC<HeroBannerDetailProps> = ({
  image,
  title,
  fontFamily,
  fontSizeM,
  subTitle,
  paragraph,
  secondaryColor,
  backgroundColor,
  fontheightM,
  style,
}: HeroBannerDetailProps) => {
  return (
    <HeroBannerDetailComponent secondaryColor={secondaryColor} backgroundColor={backgroundColor}>
      <HeroBannerDetailContent>
        <HeroBannerDetailImage image={image}>
          <img src={`/images/landingpage/detailpage/${image}.webp`} alt="herobanner image" />
        </HeroBannerDetailImage>
        <div>
          <HeroBannerDetailTitle
            fontFamily={fontFamily}
            fontSizeM={fontSizeM}
            fontheightM={fontheightM}
            style={style}
          >
            {title}
          </HeroBannerDetailTitle>
          <h3>{subTitle}</h3>
          <p>
            <HeroBannerDetailIconMobile>{SVGIcon()}</HeroBannerDetailIconMobile>
            {paragraph}
          </p>
        </div>
      </HeroBannerDetailContent>
      <HeroBannerDetailIcon>{SVGIcon()}</HeroBannerDetailIcon>
    </HeroBannerDetailComponent>
  )
}

export default HeroBannerDetail
